// @owners { team: patients }
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from '~shared/helpers/apiHelper';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';

export type OnboardStateResponse = {
  onboard_state: string;
};

export type WelcomeTrackerResponse = {
  provider_name: string;
};

export const onboarding = createQueryKeys('onboarding', {
  onboardState: ({ tempPassword }: { tempPassword: string }) => ({
    queryKey: [tempPassword],
    queryFn: async (): Promise<OnboardStateResponse> => {
      const response = await get('/users/onboard_state', { temp_password: tempPassword });
      if (response.error) {
        throw new Error(getErrorMessageFromResponse(response));
      }
      return response;
    },
  }),
  welcomeTracker: ({ tempPassword }: { tempPassword: string }) => ({
    queryKey: [tempPassword],
    queryFn: async (): Promise<WelcomeTrackerResponse> => {
      const response = await get('/users/welcome_tracker', { temp_password: tempPassword });
      if (response.error) {
        throw new Error(getErrorMessageFromResponse(response));
      }
      return response;
    },
  }),
});
